'use client';
import { CheckBoxCheck } from '../../../../public/Images';
import classes from './styles.module.scss';
export enum CheckBoxVariants {
    default = 'default',
    contactInfo = 'contactInfo',
}
const CustomCheckBox = ({
    selected,
    checkBoxClicked,
    variant = CheckBoxVariants.default,
}: {
    selected: boolean;
    checkBoxClicked: () => void;
    variant?: CheckBoxVariants;
}) => {
    return (
        <div
            onClick={() => checkBoxClicked()}
            className={`${classes.container} ${classes[variant]} ${
                selected ? classes.active : ''
            }`}
        >
            {selected && (
                <img
                    className={classes[variant + '__check']}
                    src={CheckBoxCheck.src}
                    alt=""
                />
            )}
        </div>
    );
};

export default CustomCheckBox;
